import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

type CypressIds = typeof cypressIds;

type ApplyCypressData = (name?: string) => Record<string, string | undefined>;

type UseCypressDataReturn = [CypressIds, ApplyCypressData];

const useCypressData = (): UseCypressDataReturn => {
	return [cypressIds, applyCypressData];
};

export { useCypressData };
